import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteItem,
  fetchPaginationData,
  updateStatus,
} from "../../utils/apiUtils";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import {
  ActionButton,
  checkImage,
  PlusButton,
  ToggleSwitch,
} from "../../Components/TableHelper";
import { formatDate } from "../../utils/constant";
import TableSearch from "../../Components/TableSearch";
import PerPageSelect from "../../Components/PerPageSelect";
import { useDebounce } from "../../hooks/useDebounce";

const PageBanner = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [nextSortOrder, setNextSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(25);
  const [search, setSearch] = useState("");
  const navigator = useNavigate();

  const fetchDataPagination = async (
    page = 1,
    currentSearch = search,
    currentPerPage = perPage,
  ) => {
    const requestData = {
      perPage: currentPerPage,
      pageNo: page,
      search: currentSearch,
    };
    await fetchPaginationData(
      "pagebanner/banner-pagination",
      requestData,
      setdata,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextSortOrder,
    );
  };
  useEffect(() => {
    fetchDataPagination(1);
  }, []);

  const debouncedFetch = useDebounce((searchValue) => {
    fetchDataPagination(1, searchValue);
  }, 500);

  const handleSearchChange = (value) => {
    setSearch(value);
    debouncedFetch(value);
  };
  const handlePerPageChange = (value) => {
    setPerPage(value);
    fetchDataPagination(1, search, value);
  };
  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "pagebanner/delete",
        deleteItemId?._id,
        fetchDataPagination,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleStatusToggle = async (item) => {
    const updated = await updateStatus(
      item?._id,
      "pageBanner",
      "Page Banner"
    );

    if (!updated) return;

    setdata((prev) =>
      prev.map((curr) =>
        curr._id === updated._id
          ? { ...curr, isActive: updated.isActive }
          : curr,
      ),
    );
  };

  const handleAdd = () => {
    navigator("/add-page-banner", { state: { sortOrder: nextSortOrder } });
  };
  const handleEditClick = (item) => {
    navigator("/add-page-banner", {
      state: item,
    });
  };

  const Tableheader = [
    "No.",
    "Desktop Img",
    "Menu",
    "Title",
    "Is Active",
    "Updated At",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Page Banners", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">Page Banners</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <PerPageSelect value={perPage} onChange={handlePerPageChange} />
          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <TableSearch
              value={search}
              onChange={handleSearchChange}
              placeholder="Search By Title..."
            />
            <PlusButton handleAdd={handleAdd} module={"Page Banner"} />
          </div>
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className=" custom-table table table-striped"
                    id="pageBannertable"
                  >
                    <thead>
                      <tr>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold " key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : data?.length > 0 ? (
                        data.map((item, index) => {
                          return (
                            <tr key={item._id || index}>
                              <td>{(currentPage - 1) * perPage + index + 1}</td>
                              <td>{checkImage(item.desktopImage)}</td>
                              <td>{item.menuId?.menuName}</td>
                              {/* <td>
                                {item.subMenuId?.subMenuName
                                  ? item.subMenuId?.subMenuName
                                  : "-"}
                              </td> */}
                              <td>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.title,
                                  }}
                                />
                              </td>
                              <td>
                                <ToggleSwitch
                                  data={item}
                                  name="isActive"
                                  checked={item.isActive}
                                  handleStatusToggle={handleStatusToggle}
                                  module={"Page Banner"}
                                />
                              </td>
                              <td>{formatDate(item.updatedAt)}</td>
                              <td>
                                <ActionButton
                                  data={item}
                                  handleEditClick={handleEditClick}
                                  handleDelete={handleDelete}
                                  module={"Page Banner"}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            module={"Page Banner"}
            itemName="page banner"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default PageBanner;
